import { GameState } from '../game/GameState';
import { ArmyManager } from './ArmyManager';
import { CampaignAI } from './CampaignAI';
import { DiplomacyManager } from './DiplomacyManager';
import { DynastyManager } from './DynastyManager';
import { EconomyManager } from './EconomyManager';
import { EspionageManager } from './EspionageManager';
import { EventManager } from './EventManager';
import { NavalManager } from './NavalManager';
import { NavalSiegeManager } from './NavalSiegeManager';
import { IdentityManager } from './IdentityManager';
import { MissionManager } from './MissionManager';
import { ProvinceManager } from './ProvinceManager';
import { RecruitmentManager } from './RecruitmentManager';
import { ScenarioManager } from './ScenarioManager';
import { SupplyManager } from './SupplyManager';
import { TechnologyManager } from './TechnologyManager';
import { WarManager } from './WarManager';

export class TurnManager {
  static readonly instance = new TurnManager();

  endMonth() {
    const campaign = GameState.instance.requireCampaign();
    ProvinceManager.instance.processConstruction();
    NavalManager.instance.processMonth();
    NavalSiegeManager.instance.applyMonthlyPressure();
    EconomyManager.instance.processMonth();
    RecruitmentManager.instance.processMonth();
    SupplyManager.instance.processMonth();
    ArmyManager.instance.advancePlannedMovements();
    WarManager.instance.processMonth();
    NavalManager.instance.refreshBlockades();
    NavalSiegeManager.instance.syncFlags();
    DynastyManager.instance.processMonth();
    IdentityManager.instance.processMonth();
    DiplomacyManager.instance.processMonth();
    TechnologyManager.instance.processMonth();
    EspionageManager.instance.processMonth();
    ScenarioManager.instance.processMonth();
    EventManager.instance.maybeTriggerEvent();
    CampaignAI.instance.processMonth();
    MissionManager.instance.processMonth();
    campaign.month++;
    if (campaign.month > 12) {
      campaign.month = 1;
      campaign.year++;
    }
    campaign.turn++;
    GameState.instance.updateVictoryProgress();
    GameState.instance.log('A new month begins.');
  }
}